import { Group, Paper, Stack, Title } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";

import { TextWrapper } from "@/components/TextWrapper";
import { DotPhraseRichTextField } from "@/dot-phrases";
import { EncounterNotesType } from "@/encounters/constants/encounter-notes-type";
import { EncounterAnswersFormType } from "@/encounters/zod-schemas/encounter-answers";

import EncounterFormNoteReview from "./EncounterFormNoteReview";

export interface EncounterFormNoteProps {
  title: string;
  subtitle?: string;
  type: EncounterNotesType;
  isEncounterActive: boolean;
  isAmendment?: boolean;
  form: UseFormReturnType<EncounterAnswersFormType>;
}

export default function EncounterFormNote({
  title,
  subtitle,
  type,
  isEncounterActive,
  isAmendment,
  form,
}: EncounterFormNoteProps) {
  const noteTestId =
    type === EncounterNotesType.CLIENT_SUMMARY_NOTE
      ? "encounter-client-summary-editor"
      : "encounter-note";

  if (!isEncounterActive && !isAmendment) {
    return <EncounterFormNoteReview title={title} value={form.values[type]} />;
  }

  return (
    <Paper mt="xs" radius="lg" mb={{ base: "xs", xs: "xl" }}>
      <Group
        align="center"
        justify="space-between"
        pb={{ base: 0, xs: "xs" }}
        mx={{ base: "xs", md: "xl" }}
        pt={{ base: "xs", xs: "md", sm: "lg", md: "xl" }}
      >
        <Stack gap={0}>
          <Title order={3} c="burgundy.9">
            {title}
          </Title>
          {subtitle && <TextWrapper size="sm">{subtitle}</TextWrapper>}
        </Stack>
      </Group>
      <DotPhraseRichTextField
        radius="lg"
        data-testid={noteTestId}
        px={{ base: "xs", md: "xl" }}
        pb={{ base: "xs", xs: "xl" }}
        {...form.getInputProps(type)}
      />
    </Paper>
  );
}
